import axios from "axios";
import FileSaver from "file-saver";
import { Client } from "../models/Client";
import { User } from "../models/User";
import { DataPaginate } from "../models/utils/DataPaginate";
import { IFilter } from "../models/utils/filter/FilterType.interface";
import { convertFiltersToQuery } from "./utils/serviceHelper";

function list(page: number, search?: string, filters?: IFilter[]) {
  let params = `?page=${page}`;
  if (search) {
    params = `${params}&search=${search}`;
  }
  if (filters) {
    params = `${params}${convertFiltersToQuery(filters)}`;
  }

  return axios
    .get(`${process.env.REACT_APP_API_URL}admins/clients${params}`)
    .then((response: any) => {
      const dataPaginate = new DataPaginate(response.data);
      dataPaginate.setData(dataPaginate.data.map((item) => new Client(item)));

      return dataPaginate;
    });
}

// Export CSV des utilisateurs actifs et de leurs comptes clients (RAG-41).
// Le jeton admin est ajoute automatiquement par l'intercepteur axios.
// La meme recherche que la liste des clients est transmise a l'API.
function exportUsers(search?: string) {
  let params = "";
  if (search) {
    params = `?search=${encodeURIComponent(search)}`;
  }

  return axios
    .get(`${process.env.REACT_APP_API_URL}admins/exports/users.csv${params}`, {
      responseType: "blob",
    })
    .then((response: any) => {
      const disposition: string =
        response.headers["content-disposition"] || "";
      const match = disposition.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : "utilisateurs.csv";

      FileSaver.saveAs(response.data, filename);
    });
}

function find(id: string) {
  return axios
    .get(`${process.env.REACT_APP_API_URL}admins/clients/${id}`)
    .then((response) => new Client(response.data));
}

function patchDisable(id: any, value: boolean) {
  return axios
    .patch(
      `${process.env.REACT_APP_API_URL}admins/clients/${id}/disable?value=${value}`
    )
    .then((response) => new Client(response.data));
}

//TODO - Voir avec Loïc pour la route API qui permet de récupérer les utilisateurs d'un client
function findUsers(clientId: number, page: number, search?: string, filters?: IFilter[]){
  let params = `?page=${page}`;
  if (search) {
    params = `${params}&search=${search}`;
  }
  if (filters) {
    params = `${params}${convertFiltersToQuery(filters)}`;
  }

  return axios
    .get(`${process.env.REACT_APP_API_URL}admins${params}`)
    .then((response: any) => {
      const dataPaginate = new DataPaginate(response.data);
      dataPaginate.setData(dataPaginate.data.map((item) => new User(item)));

      return dataPaginate;
    });

}

export default {
  list,
  exportUsers,
  find,
  patchDisable,
  findUsers
};
